import React, { useState } from 'react'

import { UserAdvertisementsResponse } from 'core'
import DiscountType from 'core/application/marketplace/DiscountType'

import { Alert, Button, Card, Divider, Icon, Tag } from 'common/components'

import htmlParser from '../../../../../common/htmlParser'
import AdvertisementModal from '../advertisementModal'

import './index.less'

export type MarketplaceCardProps = {
  advertisement: UserAdvertisementsResponse
}

function MarketplaceCard({ advertisement }: MarketplaceCardProps) {
  const [showLeavingModal, setShowLeavingModal] = useState(false)

  const handleShowLeavingModal = (show: boolean) => setShowLeavingModal(show)

  return (
    <Card className="MarketplaceCard mx-8">
      <div>
        <div className="p-8">
          <div className="flex flex__center w-100  mb-8">
            <img className="w-100" src={advertisement.logoImage} alt="icon" />
          </div>
          <div className="p-8">
            {/*<div className="mb-8">*/}
            {/*  <Tag>*/}
            {/*    <div className="color-gray-9 font-12">{advertisement.discountCode}</div>*/}
            {/*  </Tag>*/}
            {/*</div>*/}
            <div className="MarketplaceCard-title flex flex_space_between flex__align_center mb-16">
              <div className="font-20 text-semi-bold color-gray-9 mr-8">{advertisement.name}</div>
              <Tag>
                <div className="color-white">
                  {advertisement.discountType === DiscountType.FixedAmount
                    ? `$${advertisement.discount}`
                    : `${advertisement.discount}%`}{' '}
                  OFF
                </div>
              </Tag>
            </div>
            {advertisement.summary && (
              <Alert className="bg-gray-2 border-none" message={htmlParser(advertisement.summary)} />
            )}
          </div>
        </div>
        <Divider className="m-0" />
        <div className="flex flex__center w-100 px-16 py-8">
          <Button
            size="default"
            htmlType="button"
            type="default"
            className="w-100"
            onClick={() => handleShowLeavingModal(true)}
          >
            Get offer <Icon type="fa fa-external-link" fontAwesome className="ml-8" />
          </Button>
        </div>
      </div>
      <AdvertisementModal
        advertisement={advertisement}
        showModal={showLeavingModal}
        onClose={() => handleShowLeavingModal(false)}
      />
    </Card>
  )
}

export default MarketplaceCard
